// Developer hooks: window.__MK (smoke, shots) and #test= shortcuts
import Matter from 'matter-js';
import { Registry } from '../core/registry';
import { Physics } from '../core/physics';
import { toScreen, G, show, LEVELS, WSTART, WORLDS } from './state';
import { Store } from '../core/store';
import { updateHud } from './hud';
import { loadLevel, startPlay, rebuild } from './play';
import { openIntro } from './intro';
import { openMap } from './map';
import { openParent } from './parent-panel';

const MK = { Registry, Physics, Matter, G, Store, loadLevel, openMap, startPlay, show, openIntro, openParent, LEVELS, WSTART, rebuild, updateHud };
/** window.__MK as the browser tools see it (typed on Window in src/env.d.ts) */
export type MKApi = typeof MK;
window.__toScreen = toScreen; window.__MK = MK;
// Developer shortcut: #test=<world>:<level>[:sol][:play][:hint][:map][:freeze]
// <level> is the number within the world (1, 2, …) or the level id: #test=socks:3:sol:play, #test=dishes:first-roll
export function devJump() {
  const m = /#test=([a-z]+):([a-z0-9-]+)(.*)/.exec(location.hash); if (!m) return;
  const wi = WORLDS.findIndex(w => w.k === m[1]); if (wi < 0) return;
  const end = WSTART[wi + 1] != null ? WSTART[wi + 1] : LEVELS.length;
  const li = /^\d+$/.test(m[2]) ? WSTART[wi] + (+m[2]) - 1 : LEVELS.findIndex((L, i) => i >= WSTART[wi] && i < end && L.id === m[2]);
  if (li < WSTART[wi] || li >= end || !LEVELS[li]) return;
  Store.d.settings.testAll = true;
  if (/freeze/.test(m[3])) G.freeze = true;
  if (!Store.prof()) { const id = 'dev'; Store.d.profiles.push({ id, prog: {}, ch: { animal: 'frog', shirt: '#4A90E2', shoes: '#E94B4B' } }); Store.d.cur = id; }
  const p = Store.prof()!; p.intros = { ...Object.fromEntries(Registry.coreIntros().map(k => [k, 1])), [LEVELS[li].intro as string]: 1 };
  loadLevel(li);
  if (/sol/.test(m[3])) { G.pl = LEVELS[li].solution.map(q => ({ ...q })); rebuild(); updateHud(); }
  if (/hint/.test(m[3])) { G.hintStep = 99; }
  if (/play/.test(m[3])) startPlay();
  if (/map/.test(m[3])) { G.mapW = wi; openMap(); }
}
addEventListener('hashchange', devJump);
